<template>
  <section>
    <div v-bind:class="{videoCnt: true, open: openVideo}">
      <div class="videoTitle" v-if="podcast">{{podcast.title}}</div>
      <div class="closeBtn" v-on:click="closeVideo"></div>
      <div class="videoWrapper">
        <div class="theVideo">
          <VuePlyr ref="video">
            <video></video>
          </VuePlyr>
        </div>
        <div class="videoInfo" v-if="podcast">
          <h4>{{podcast.title}}</h4>
          <p>{{podcast.description}}</p>
        </div>
      </div>
    </div>
    <div v-bind:class="{poster: true, open: podcast && podcast.video && openAudio
      && openPoster}"
      v-on:click="playVideo">
      <div class="posterImg" v-if="podcast && podcast.video"
        v-bind:style="{backgroundImage: `url(${podcast.thumb})`}">
        <div class="imgOverlay">
          <div class="playBtn">
            <div class="playIcon"></div>
            Tonton Video
          </div>
        </div>
      </div>
    </div>
    <div v-bind:class="{playerCnt: true, open: podcast !== null && openAudio}">
      <div class="contentInfo">
        <div class="contentImg" v-if="podcast"
          v-bind:style="{backgroundImage: `url(${podcast.thumb})`}"></div>
        <h5>Sedang diputar</h5>
        <h4 v-if="podcast">{{podcast.title}} <span>by Author</span></h4>
      </div>
      <VuePlyr ref="plyr">
        <audio></audio>
      </VuePlyr>
    </div>
  </section>
</template>

<script>
import VuePlyr from 'vue-plyr';

export default {
  components: { VuePlyr },
  data() {
    return {
      podcast: null,
      openVideo: false,
      startAt: null,
      videoStartAt: null,
      openAudio: false,
      videoInitialized: false,
      openPoster: true,
    };
  },
  methods: {
    play(item) {
      this.videoInitialized = false;
      if (!this.podcast || this.podcast.id !== item.id) {
        this.podcast = item;
        this.startAt = this.podcast.startAt;
        if (!this.podcast.audio) {
          if (this.podcast.video) this.playVideo();
          return;
        }
        this.player.source = {
          type: 'audio',
          title: this.podcast.title,
          sources: [
            {
              src: this.podcast.audio.url,
              type: 'audio/mpeg',
            },
          ],
        };
        this.openAudio = true;
        this.openPoster = true;
        this.player.stop();
        this.player.play();
        this.player.on('playing', () => {
          this.openPoster = true;
          if (this.startAt) {
            this.player.currentTime = this.startAt;
            this.startAt = null;
          }
        });
        this.player.on('pause', () => { this.openPoster = false; });
      } else {
        if (!this.podcast.audio) {
          if (this.podcast.video) this.playVideo();
          return;
        }
        this.openAudio = true;
        this.player.play();
      }
    },
    playVideo() {
      if (this.videoInitialized) {
        this.openVideo = true;
        this.openAudio = false;
        this.player.pause();
        if (this.podcast.audio) {
          this.video.currentTime = this.player.currentTime;
        }
        this.video.play();
      } else {
        this.videoInitialized = true;
        this.openVideo = true;
        this.openAudio = false;
        const sources = [];
        if (this.podcast.video.vid1080p) {
          sources.push({
            src: this.podcast.video.vid1080p,
            type: 'video/mp4',
            size: 1080,
          });
        }
        if (this.podcast.video.vid720p) {
          sources.push({
            src: this.podcast.video.vid720p,
            type: 'video/mp4',
            size: 720,
          });
        }
        if (this.podcast.video.vid480p) {
          sources.push({
            src: this.podcast.video.vid480p,
            type: 'video/mp4',
            size: 480,
          });
        }
        if (this.podcast.video.vid360p) {
          sources.push({
            src: this.podcast.video.vid360p,
            type: 'video/mp4',
            size: 360,
          });
        }
        this.video.source = {
          type: 'video',
          title: this.podcast.title,
          sources,
        };
        this.player.pause();
        if (this.podcast.audio) {
          this.videoStartAt = this.player.currentTime;
        }
        this.video.play();
        this.video.on('playing', () => {
          if (this.videoStartAt) {
            this.video.currentTime = this.videoStartAt;
            this.videoStartAt = null;
          }
        });
      }
    },
    closeVideo() {
      this.openVideo = false;
      if (this.podcast.audio) {
        this.openAudio = true;
        this.player.currentTime = this.video.currentTime;
        if (this.video.playing) this.player.play();
      }
      this.video.pause();
    },
  },
  computed: {
    player() {
      return this.$refs.plyr.player;
    },
    video() {
      return this.$refs.video.player;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.videoCnt{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 100vh;
  z-index: 99;
  background: #eee;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  opacity: 0;
  backdrop-filter: saturate(180%) blur(20px);
  background-color: rgba(200,200,200,.6);

  .plyr--video{
    .plyr__controls{
      @media (max-width: 760px) {
        .plyr__controls__item.plyr__volume,
        .plyr__controls__item.plyr__time,
        .plyr__controls__item.plyr__menu{
          display: none !important;
        }
      }
    }
  }
  @media (max-width: 990px) {
    display: block !important;
  }

  &.open{
    bottom: 0;
    opacity: 1;
  }
  .closeBtn{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    right: 20px; top: 10px;
    background-image: url(../assets/close.png);
    background-size: 16px auto;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    opacity: .7;
    &:hover{
      background-color: #fff;
      opacity: 1;
    }
    @media (max-width: 990px) {
      z-index: 99;
      left: 10px !important;
      top: 5px !important;
      right: auto !important;
      background-image: url(../assets/arrow-down-bold.png) !important;
      opacity: .9 !important;
    }
  }
  .videoTitle{
    position: absolute;
    z-index: 9;
    top: 0; left: 0; right: 0;
    padding: 0 20px;
    background-color: #fff;
    color: #444;
    height: 50px;
    line-height: 50px;
    padding-left: 60px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    display: none;
    box-shadow: 0 0 4px rgba(0,0,0,.2);
    @media (max-width: 990px) {
      display: block !important;
    }
  }
  .videoWrapper{
    display: flex;
    width: 960px;
    margin-bottom: 40px;
    border-radius: 5px;
    overflow: hidden;
    .theVideo{
      width: 600px;
      height: 600px;
      background-color: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .videoInfo{
      width: calc(100% - 600px);
      box-sizing: border-box;
      background-color: #fff;
      padding: 30px;
      height: 600px;
      overflow-y: auto;
      h4{
        margin: 0;
        font-size: 30px;
        line-height: 1.3;
        @media (max-width: 990px) {
          font-size: 20px !important;
        }
      }
      p{
        white-space: pre-line;
      }
    }
    @media (max-width: 990px) {
      display: block !important;
      width: 100% !important;
      height: calc(100% - 50px);
      border-radius: 0 !important;
      margin-bottom: 0 !important;
      overflow: auto !important;
      padding-top: 50px !important;
      .theVideo{
        width: 100% !important;
        height: auto !important;
      }
      .videoInfo{
        width: 100% !important;
        height: auto !important;
        overflow: hidden !important;
        padding: 20px !important;
      }
    }
  }
}
.poster{
  position: fixed;
  bottom: 90px; right: 30px;
  background-color: #222;
  z-index: 999;
  transition: all .2s ease;
  height: 160px;
  width: 160px;
  border-radius: 5px;
  box-shadow: 2px 2px 4px rgba(0,0,0,.2);
  cursor: pointer;
  overflow: hidden;
  opacity: 0;
  bottom: -160px;
  transition: all .3s ease;
  bottom: 90px;
  right: -164px;
  &.open{
    // bottom: 90px;
    right: 30px;
    opacity: 1;
    @media (max-width: 760px) {
      right: 16px;
    }
  }
  .posterImg{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    background-size: cover;
    background-position: center;
  }
  .imgOverlay{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: rgba(0,0,0,.6);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all .2s ease;
    z-index: 2;
    .playBtn{
      position: relative;
      font-size: 12px;
      padding: 0;
      border-radius: 100px;
      font-weight: bold;
      text-align: center;
      .playIcon{
        width: 40px;
        height: 40px;
        background-image: url(../assets/play_circle_outline-white-18dp.svg);
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        margin: 0 auto 2px;
      }
      span{
        display: block;
        font-size: 12px;
        font-weight: normal;
      }
    }
  }
  &:hover{
    .imgOverlay{
      opacity: 1;
    }
  }
  @media (max-width: 760px) {
    width: 80px; height: 80px;
    bottom: 80px;
    .imgOverlay{
      opacity: 1;
      background: #222;
      .playBtn{
        font-size: 8px;
      }
    }
  }
}
.playerCnt{
  position: fixed;
  bottom: -74px; left: 0; right: 0;
  background-color: #222;
  z-index: 999;
  transition: all .3s ease;
  &.open{
    bottom: 0;
  }
  .contentInfo{
    position: absolute;
    left: 80px;
    z-index: 2;
    color: #fff;
    margin-top: 12px;
    padding-left: 60px;
    @media (max-width: 760px) {
      left: 70px;
    }
    .contentImg{
      width: 40px;
      height: 40px;
      background-color: #fff;
      position: absolute;
      left: 0; top: 0;
      border-radius: 5px;
      background-position: center;
      background-size: cover;
    }
    h5{
      margin: 0;
      color: #bbb;
    }
    h4{
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 60%;
      @media (max-width: 760px) {
        max-width: 200px;
      }
      span{
        font-weight: normal;
        color: #999;
        display: none;
      }
    }
  }
  .plyr--audio{
    position: relative;
    .plyr__controls{
      padding: 16px;
      background: #222;
      color: #fff;
      .plyr__controls__item:first-child{
        transform: scale(1.4);
        border-radius: 50%;
      }
      .plyr__controls__item.plyr__progress__container{
        position: absolute;
        left: -2px; right: -2px; top: -12px;
        padding: 0; margin: 0;
        .plyr__tooltip{
          background: #222;
          color: #fff;
          &:before{
            border-top: 4px solid #222;
          }
        }
        .plyr--full-ui input[type=range]{
        }
      }
      .plyr__controls__item.plyr__time{
        color: #999;
      }
      @media (max-width: 760px) {
        .plyr__controls__item.plyr__volume,
        .plyr__controls__item.plyr__time,
        .plyr__controls__item.plyr__menu{
          display: none;
        }
      }
    }
  }
}
</style>
